import { haversineDistance, getStoredLocation, setStoredLocationSource } from './location.js';

function setLocationName(name) {
  document.querySelectorAll('.js-header-location-name').forEach(function (el) {
    el.textContent = name;
  });
}

function dispatchLocationEvent(locationId, locationName) {
  document.dispatchEvent(new CustomEvent('mowgli_location_changed', {
    detail: { locationId: locationId, locationName: locationName }
  }));
}

function syncAllSelectors(locationId, locationName) {
  document.querySelectorAll('.js-location-select').forEach(function (select) {
    select.value = locationId;

    if (select._mowgliChoices) {
      select._mowgliChoices.setChoiceByValue(locationId || '');
    }
  });

  document.querySelectorAll('.js-location-btn').forEach(function (btn) {
    btn.classList.toggle('active', btn.getAttribute('data-location-id') === locationId);
  });

  setLocationName(locationName);
}

function updateMenuLinks() {
  var locationId = sessionStorage.getItem('mowgli_location_id') || '';
  var locationName = sessionStorage.getItem('mowgli_location_name');
  var locationSlug = sessionStorage.getItem('mowgli_location_slug') || (locationName ? locationName.toLowerCase().replace(/\s+/g, '-') : null);

  document.querySelectorAll('.js-menu-link').forEach(function (link) {
    if (locationId && locationSlug) {
      // Location known: link straight to the restaurant's menus, no picker needed.
      link.href = '/restaurants/' + locationSlug + '/menus/';
      link.removeAttribute('data-bs-toggle');
      link.removeAttribute('data-bs-target');
      link.removeAttribute('aria-controls');
    } else {
      // Location unknown: fall back to opening the location picker offcanvas.
      link.href = '/menus';
      link.setAttribute('data-bs-toggle', 'offcanvas');
      link.setAttribute('data-bs-target', '#offcanvasBottomLocations');
      link.setAttribute('aria-controls', 'offcanvasBottomLocations');
    }
  });

  updateFeaturedMenuLinks(locationId, locationSlug);
}

function getFrontPageRestaurantData() {
  var restaurantDataNode = document.getElementById('front-page-restaurant-data');

  if (!restaurantDataNode) {
    return [];
  }

  try {
    return JSON.parse(restaurantDataNode.textContent || '[]');
  } catch (error) {
    return [];
  }
}

function updateFeaturedMenuLinks(locationId, locationSlug) {
  document.querySelectorAll('.js-featured-menu-link').forEach(function (link) {
    var defaultHref = link.getAttribute('data-default-href') || link.href;
    var menuSlug = link.getAttribute('data-menu-slug') || '';

    if (!locationId || !locationSlug || !menuSlug) {
      link.href = defaultHref;
      return;
    }

    var restaurant = getFrontPageRestaurantData().find(function (item) {
      return String(item.id) === String(locationId);
    });

    if (!restaurant || !restaurant.slug) {
      link.href = defaultHref;
      return;
    }

    if (Array.isArray(restaurant.menuSlugs) && restaurant.menuSlugs.indexOf(menuSlug) !== -1) {
      link.href = '/restaurants/' + restaurant.slug + '/menus/' + menuSlug + '/';
      return;
    }

    link.href = defaultHref;
  });
}

function getLocationMetaById(locationId) {
  if (!locationId) {
    return null;
  }

  var selector = '[data-location-id="' + String(locationId).replace(/"/g, '\\"') + '"]';
  var sourceNode = document.querySelector('.js-location-btn' + selector)
    || document.querySelector('.js-location-select option' + selector);

  if (!sourceNode) {
    return null;
  }

  var locationName = sourceNode.getAttribute('data-location-name') || sourceNode.textContent || '';
  var locationSlug = sourceNode.getAttribute('data-location-slug')
    || (locationName ? locationName.toLowerCase().replace(/\s+/g, '-') : '');

  return {
    name: locationName,
    slug: locationSlug
  };
}

/**
 * Persist a location selection to sessionStorage and sync all UI.
 *
 * @param {string} locationId
 * @param {string} locationName
 * @param {'manual'|'geolocation'} [source='manual'] - what triggered this selection
 * @param {string} [locationSlug]
 */
function saveLocation(locationId, locationName, source, locationSlug) {
  if (!locationId) {
    sessionStorage.removeItem('mowgli_location_id');
    sessionStorage.removeItem('mowgli_location_name');
    sessionStorage.removeItem('mowgli_location_slug');
    setStoredLocationSource(null);
    syncAllSelectors('', '');
    dispatchLocationEvent('', '');
    updateMenuLinks();
    return;
  }

  sessionStorage.setItem('mowgli_location_id', locationId);
  sessionStorage.setItem('mowgli_location_name', locationName);
  sessionStorage.setItem('mowgli_location_slug', locationSlug || (locationName ? locationName.toLowerCase().replace(/\s+/g, '-') : ''));
  setStoredLocationSource(source || 'manual');
  syncAllSelectors(locationId, locationName);
  dispatchLocationEvent(locationId, locationName);
  updateMenuLinks();
}

function restoreLocation() {
  var storedId = sessionStorage.getItem('mowgli_location_id');
  var storedName = sessionStorage.getItem('mowgli_location_name');
  var storedSlug = sessionStorage.getItem('mowgli_location_slug') || (storedName ? storedName.toLowerCase().replace(/\s+/g, '-') : '');

  if (storedId && (!storedName || !storedSlug)) {
    var resolvedMeta = getLocationMetaById(storedId);

    if (resolvedMeta) {
      storedName = storedName || resolvedMeta.name;
      storedSlug = storedSlug || resolvedMeta.slug;

      if (storedName) {
        sessionStorage.setItem('mowgli_location_name', storedName);
      }

      if (storedSlug) {
        sessionStorage.setItem('mowgli_location_slug', storedSlug);
      }
    }
  }

  if (!storedId || !storedSlug) {
    return;
  }

  if (shouldSyncMenuRouteWithStoredLocation(storedSlug)) {
    maybeRedirectRestaurantPage(storedSlug);
    return;
  }

  syncAllSelectors(storedId, storedName || '');
  dispatchLocationEvent(storedId, storedName || '');
  updateMenuLinks();
}

function initSelect() {
  document.querySelectorAll('.js-location-select').forEach(function (select) {
    if (window.Choices && !select._mowgliChoices) {
      select._mowgliChoices = new Choices(select, {
        searchEnabled: false,
        shouldSort: false,
        itemSelectText: ''
      });
    }

    select.addEventListener('change', function () {
      var selected = this.options[this.selectedIndex];
      var locationSlug = selected.getAttribute('data-location-slug');

      saveLocation(this.value, selected.getAttribute('data-location-name'), 'manual', locationSlug);
      if (locationSlug && maybeRedirectRestaurantPage(locationSlug)) {
        return;
      }

      closeOpenOffcanvas();
    });
  });
}

function maybeRedirectRestaurantPage(newSlug) {
  var currentPath = window.location.pathname || '';
  var menusUrl = '/restaurants/' + newSlug + '/menus/';
  var locationUrl = '/restaurants/' + newSlug + '/';
  var match = currentPath.match(/^\/restaurants\/([^\/]+)(\/.*)?$/);
  var standaloneMenuMatch = currentPath.match(/^\/menus\/([^\/]+)\/?$/);
  var isMenusPage = /^\/menus\/?$/.test(currentPath);
  var targetUrl = locationUrl;

  if (match) {
    targetUrl = '/restaurants/' + newSlug + (match[2] || '/');
  } else if (standaloneMenuMatch) {
    targetUrl = '/restaurants/' + newSlug + '/menus/' + standaloneMenuMatch[1] + '/';
  } else if (isMenusPage) {
    targetUrl = menusUrl;
  }

  fetch(targetUrl, { method: 'HEAD' })
    .then(function (res) {
      if (res.ok) {
        window.location.href = targetUrl;
        return;
      }

      return fetch(menusUrl, { method: 'HEAD' }).then(function (fallback) {
        window.location.href = fallback.ok ? menusUrl : locationUrl;
      });
    })
    .catch(function () {
      window.location.href = locationUrl;
    });

  return true;
}

function shouldSyncMenuRouteWithStoredLocation(storedSlug) {
  if (!storedSlug) {
    return false;
  }

  var path = window.location.pathname || '';
  var isMenusLanding = /^\/menus\/?$/.test(path);
  var isStandaloneMenuPage = /^\/menus\/[^\/]+\/?$/.test(path);

  if (isMenusLanding || isStandaloneMenuPage) {
    return true;
  }

  var routeMatch = path.match(/^\/restaurants\/([^\/]+)(\/.*)?$/);
  if (!routeMatch) {
    return false;
  }

  var currentRestaurantSlug = routeMatch[1] || '';
  var isMenuRoute = /^\/restaurants\/[^\/]+\/menus(\/|$)/.test(path) || /^\/restaurants\/[^\/]+\/menu\/?$/.test(path);

  return isMenuRoute && currentRestaurantSlug !== storedSlug;
}

function closeOpenOffcanvas() {
  var openOffcanvas = document.querySelector('.offcanvas.show');
  if (!openOffcanvas || !window.bootstrap || !window.bootstrap.Offcanvas) {
    return;
  }

  var bsOffcanvas = window.bootstrap.Offcanvas.getInstance(openOffcanvas);
  if (bsOffcanvas) {
    bsOffcanvas.hide();
  }
}

function initFrontPageRestaurantSlider() {
  var restaurantSlider = document.querySelector('.js-restaurant-slider');
  var restaurantDataNode = document.getElementById('front-page-restaurant-data');

  if (!restaurantSlider || !restaurantDataNode) {
    return;
  }

  var restaurantWrapper = restaurantSlider.querySelector('.swiper-wrapper');
  if (!restaurantWrapper) {
    return;
  }

  var restaurantData = [];

  try {
    restaurantData = JSON.parse(restaurantDataNode.textContent || '[]');
  } catch (error) {
    restaurantData = [];
  }

  if (!restaurantData.length) {
    return;
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function buildSlideMarkup(restaurant) {
    var locationText = restaurant.locationText
      ? '<p class="text-uppercase text-light">' + escapeHtml(restaurant.locationText) + '</p>'
      : '';

    return '<a class="swiper-slide border-radius" href="' + escapeHtml(restaurant.permalink) + '" style="background: url(\'' + escapeHtml(restaurant.image) + '\'); background-size: cover; background-position: center;">'
      + '<div class="swiper-slide-content">'
      + locationText
      + '<h3>' + escapeHtml(restaurant.title) + '</h3>'
      + '</div>'
      + '</a>';
  }

  function renderRestaurants(restaurants) {
    restaurantWrapper.innerHTML = restaurants.map(buildSlideMarkup).join('');

    if (window.Swiper && restaurantSlider.swiper) {
      restaurantSlider.swiper.update();
      restaurantSlider.swiper.slideTo(0, 0);
    }
  }

  function getRandomRestaurants(limit, excludedIds) {
    var excluded = {};
    excludedIds.forEach(function (id) {
      excluded[String(id)] = true;
    });

    return restaurantData
      .filter(function (restaurant) {
        return !excluded[String(restaurant.id)];
      })
      .sort(function () {
        return Math.random() - 0.5;
      })
      .slice(0, limit);
  }

  function getRestaurantsForLocation(locationId) {
    var selectedRestaurant = restaurantData.find(function (restaurant) {
      return String(restaurant.id) === String(locationId);
    });

    if (!selectedRestaurant) {
      return null;
    }

    var selectedRestaurants = [];

    if (selectedRestaurant.lat !== null && selectedRestaurant.lng !== null) {
      selectedRestaurants = restaurantData
        .filter(function (restaurant) {
          return restaurant.lat !== null && restaurant.lng !== null;
        })
        .map(function (restaurant) {
          return {
            restaurant: restaurant,
            distance: haversineDistance(
              selectedRestaurant.lat, selectedRestaurant.lng,
              restaurant.lat, restaurant.lng
            )
          };
        })
        .sort(function (left, right) {
          return left.distance - right.distance;
        })
        .slice(0, 3)
        .map(function (item) {
          return item.restaurant;
        });
    }

    if (!selectedRestaurants.length) {
      selectedRestaurants = [selectedRestaurant];
    }

    if (selectedRestaurants.length < 3) {
      selectedRestaurants = selectedRestaurants.concat(
        getRandomRestaurants(3 - selectedRestaurants.length, selectedRestaurants.map(function (restaurant) {
          return restaurant.id;
        }))
      );
    }

    return selectedRestaurants;
  }

  function updateRestaurants(locationId) {
    var restaurants = locationId ? getRestaurantsForLocation(locationId) : null;
    if (!restaurants || !restaurants.length) {
      return;
    }

    renderRestaurants(restaurants);
  }

  updateRestaurants(window.sessionStorage.getItem('mowgli_location_id') || '');

  document.addEventListener('mowgli_location_changed', function (event) {
    var nextLocationId = event.detail && event.detail.locationId ? event.detail.locationId : '';
    updateRestaurants(nextLocationId);
  });
}

function initButtons() {
  document.querySelectorAll('.js-location-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var locationId = this.getAttribute('data-location-id');
      var locationName = this.getAttribute('data-location-name');
      var locationSlug = this.getAttribute('data-location-slug');

      saveLocation(locationId, locationName, 'manual', locationSlug);

      // Location cards always take the visitor to the restaurant's menus page.
      if (this.classList.contains('js-location-card') && locationSlug) {
        window.location.href = '/restaurants/' + locationSlug + '/menus/';
        return;
      }

      if (locationSlug && maybeRedirectRestaurantPage(locationSlug)) {
        return;
      }

      closeOpenOffcanvas();
    });
  });
}

function init() {
  initSelect();
  initButtons();
  restoreLocation();
  initFrontPageRestaurantSlider();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

window.mowgliLocation = {
  save: saveLocation
};
